import { useEffect, useCallback } from 'react'
import { changeRole, selectUserRole, setRoleChange } from 'src/app/user'
import { OnMyUserContextChangeEvent } from 'src/types/sdk'
import { useAppDispatch, useAppSelector } from './useRTK'
import { addErrorSDKToast } from 'src/utils/helpers'

export const useOnMyUserContextChange = () => {
  const dispatch = useAppDispatch()
  const currentRole = useAppSelector(selectUserRole)
  const fn = useCallback(
    ({ role }: OnMyUserContextChangeEvent) => {
      // if we were a host and are now not a host
      if (currentRole === 'host' && role !== 'host') {
        dispatch(setRoleChange('participant')) // forcing this roll to be participant because that's all we need for the error state
        // if we weren't a host and are now a host
      } else if (currentRole !== 'host' && role === 'host') {
        dispatch(setRoleChange('host'))
      }
      dispatch(changeRole(role)) // setting the role just in case, but not likely needed with this flow
    },
    [currentRole, dispatch]
  )
  useEffect(() => {
    try {
      window.zoomSdk.addEventListener('onMyUserContextChange', fn)
    } catch {
      addErrorSDKToast('Error: cannot add onMyUserContextChange even')
    }

    return () => window.zoomSdk.removeEventListener('onMyUserContextChange', fn)
  }, [fn])
}
